module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_9016.4c301fb8.png";